const accountSetupSteps = [
  { path: "/create-account", label: "Create Account" },
  { path: "/personal-information", label: "Personal Information" },
  { path: "/location-preferences", label: "Location & Preferences" },
  { path: "/travel-interests", label: "Travel Interests" },
  { path: "/travel-preferences", label: "Travel Preferences" },
];

export default accountSetupSteps;
